import FormStateEnum from '@models/enums/FormStateEnum';
import IFormValues from '@models/IFormValues';
import axios from 'axios';
import { useState } from 'react';
import { SubmitHandler } from 'react-hook-form';

const useContactForm = (endpoint: string) => {
  const [formState, setFormState] = useState(FormStateEnum.Idle);

  const onSubmit: SubmitHandler<IFormValues> = async (payload) => {
    setFormState(FormStateEnum.Loading);
    try {
      const response = await axios.post<{ success: boolean }>(
        endpoint,
        payload,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );

      setFormState(
        response.status === 200 ? FormStateEnum.Success : FormStateEnum.Error,
      );
    } catch (err) {
      console.error(err);
      setFormState(FormStateEnum.Error);
    }
  };

  return { formState, onSubmit };
};

export default useContactForm;
